import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/dream/Desktop/work/project/jihuiduo-member-h5/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/Users/dream/Desktop/work/project/jihuiduo-member-h5/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import service from "../../service";
var state = {
  goodsList: [],
  newerList: [],
  // 新人活动列表
  goodsDuration: 0,
  newerDuration: 0,
  topImgs: [{
    "imageUrl": "https://stg-statics.jihuiduo.cn/miniapp_banners/member_top1.jpeg",
    "pageUrl": ""
  }, {
    "imageUrl": "https://stg-statics.jihuiduo.cn/miniapp_banners/member_top.jpeg",
    "pageUrl": ""
  }],
  middleImgs: [],
  bottomImgs: [],
  homeBackground: "",
  skuList: [],
  skuTotal: 2,
  homeCollage: [],
  skeletonLoading: true
};
var mutations = {
  GET_LIST: function GET_LIST(state, data) {
    if (data && data.leadTime) {
      state.goodsDuration = data.leadTime;
      state.goodsList = data.itemList || [];
    } else {
      state.goodsDuration = "notime";
    }
  },
  GET_NEW: function GET_NEW(state, data) {
    if (data && data.leadTime) {
      state.newerDuration = data.leadTime;
      state.newerList = data.itemList || [];
    } else {
      state.newerDuration = "notime";
    }
  },
  SET_BANNER: function SET_BANNER(state, data) {
    if (data[4] && data[4].length) {
      state.topImgs = data[4];
    }

    state.middleImgs = data[2] || [];
    state.bottomImgs = data[3] || [];

    if (data[500]) {
      state.homeBackground = data[500][0].imageUrl || "";
    }

    state.skeletonLoading = false;
  },
  SET_COLLAGE: function SET_COLLAGE(state, data) {
    if (data && data.length) {
      // state.homeCollage = data.splice(0,1)
      state.homeCollage = data;
    } else {
      state.homeCollage = [];
    }
  },
  SET_SKU_LIST: function SET_SKU_LIST(state, data) {
    var _state$skuList;

    state.skuTotal = data.total ? parseInt(data.total) : 0;

    (_state$skuList = state.skuList).push.apply(_state$skuList, _toConsumableArray(data.data));
  },
  SET_SKU_LIST_INIT: function SET_SKU_LIST_INIT(state, data) {
    state.skuList = [];
  }
};
var actions = {
  getList: function () {
    var _getList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, callback) {
      var _this = this;

      var commit;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                service.getHomeDetail().then(function (res) {
                  if (res.status === 200) {
                    commit("SET_BANNER", res.result.banners);
                    commit("GET_NEW", res.result.newUserExclusiveVo);
                    commit("GET_LIST", res.result.timeLimitVo);
                    commit("SET_COLLAGE", res.result.pintuanVo);
                  } else {
                    _this.$toast("获取商品失败");
                  }

                  callback && callback();
                }).catch(function (e) {
                  commit("GET_LIST", []);
                  commit("GET_NEW", []); // commit("SET_BANNER",[])

                  // commit("SET_BANNER",[])
                  callback && callback(e);
                });
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getList(_x, _x2) {
      return _getList.apply(this, arguments);
    }

    return getList;
  }(),
  getSkuList: function () {
    var _getSkuList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2, _ref3) {
      var _this2 = this;

      var commit, params, callback;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              params = _ref3.params, callback = _ref3.callback;
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                if (params.currentPage === 1) {
                  commit("SET_SKU_LIST_INIT", []);
                }

                service.getHomeSkuList(params).then(function (res) {
                  if (res.status === 200) {
                    commit("SET_SKU_LIST", res.result);
                  } else {
                    _this2.$toast("获取商品列表失败");
                  }

                  callback && callback();
                }).catch(function (e) {
                  callback && callback();
                });
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function getSkuList(_x3, _x4) {
      return _getSkuList.apply(this, arguments);
    }

    return getSkuList;
  }(),
  login: function login(_ref4) {
    var commit = _ref4.commit;
    return new Promise(function (resolve, reject) {
      commit("LOGIN_IN");
      resolve();
    });
  },
  logout: function logout(_ref5) {
    var commit = _ref5.commit;
    return new Promise(function (resolve, reject) {
      commit("LOGIN_OUT");
      resolve();
    });
  }
};

function getDurations(data) {
  if (!data.length) return [];
  var res = {};
  data.forEach(function (element) {
    var arr = element.endTime.split(/[- : T .]/);
    var endTime = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    var arrnow = element.nowTime.split(/[- : T .]/);
    var nowTime = new Date(arrnow[0], arrnow[1] - 1, arrnow[2], arrnow[3], arrnow[4], arrnow[5]);
    var totalSecond = (Date.parse(endTime) - Date.parse(nowTime)) / 1000;

    if (!res[totalSecond]) {
      res[totalSecond] = [];
    }

    element.totalSecond = totalSecond;
    res[totalSecond].push(element);
  });
  var nowarr = Object.keys(res).map(function (item) {
    return parseInt(item);
  });
  var sortArr = nowarr.sort(function (a, b) {
    a - b;
  });
  var sortRes = {};
  sortArr.forEach(function (item) {
    sortRes[item] = res[item];
  });
  return sortRes;
}

function getGoodsArr(data) {
  var durations = getDurations(data);
  var sortGoods = Object.keys(durations);
  var arr = [];
  sortGoods.forEach(function (item) {
    arr = arr.concat(durations[item]);
  }); // console.log('arr',arr)

  return arr;
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};